// Generated by scripts/styles/generate-public-styles.mjs. Do not edit.
export const publicStylesHref = "/styles/public.06b089092d2628b7.css"
export const articleStylesHref = "/styles/article-critical.b7a07fa494b248fc.css"
export const productStylesHref = "/styles/product-critical.01be0001e67cd40d.css"
export const compareStylesHref = "/styles/compare-critical.8fa71f9c27cfa131.css"
export const hubStylesHref = "/styles/hub-critical.a99c2ead50467787.css"
export const brandStylesHref = "/styles/brand-critical.9c4cdafca1fe8ba2.css"
